import { Links, Meta, Outlet, Scripts, ScrollRestoration } from 'react-router';
import { TelemetryPageTracker } from '@lunacast/lib-telemetry';
import { MediaUnlockRoot } from '@lunacast/ui-overlays/media-unlock';
import { telemetryInitOptions } from './lib/telemetry';
import './index.css';

/** overlay-web 앱 루트 레이아웃. 계측·미디어 언락·React Router 아웃렛을 감싼다. */
export default function Root() {
  return (
    <html lang="ko">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="robots" content="noindex, nofollow" />
        <Meta />
        <Links />
      </head>
      <body>
        <TelemetryPageTracker initOptions={telemetryInitOptions} />
        <MediaUnlockRoot mode="live">
          <Outlet />
        </MediaUnlockRoot>
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
}
